import React, { SVGProps } from "react";

const SvgProtrusion03Dims = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={350}
    height={302}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 350 302"
    {...props}
  >
    <path
      d="m260.655 118.193-118.01-46.81L21 1.153l239.655 117.04Z"
      fill="#2681B4"
    />
    <path d="M21 1.152v260.834L142.5 71.743 21 1.153Z" fill="#45E0FF" />
    <path
      d="M142.746 71.377 38.835 233.005 242.82 110.868 142.746 71.377Z"
      fill="#B5C7D4"
    />
    <path
      d="m21 1.152 121.5 70.591L21 261.986V1.152ZM21 1.152l239.655 117.041-118.01-46.67"
      stroke="#002839"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path d="M39.949 231.89 242.82 111.505" stroke="#3F3F3F" />
    <path
      d="m83.422 298.771-56.848-32.326M321.963 153.863 76.734 295.427M328.649 157.207 271.8 124.881"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M211.519 225.071h1.568l4.176 10.672h-1.712l-1.104-2.976h-4.384l-1.104 2.976h-1.616l4.176-10.672Zm2.464 6.4-1.728-4.688-1.744 4.688h3.472Z"
      fill="#3B3B3B"
    />
    <path
      d="M76.734 288.739V301M321.963 147.175v12.261"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="m42.178 120.423 15.606 10.032"
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M38.937 155.962h3.376c.725 0 1.322.101 1.792.304.48.202.859.458 1.136.768.288.309.485.656.592 1.04.117.384.176.757.176 1.12 0 .533-.09 1.002-.272 1.408a2.912 2.912 0 0 1-.752 1.024c-.32.266-.704.469-1.152.608a4.765 4.765 0 0 1-1.44.208h-1.936v4.192h-1.52v-10.672Zm3.44 5.168c.661 0 1.168-.166 1.52-.496.363-.342.544-.811.544-1.408 0-.608-.187-1.083-.56-1.424-.363-.352-.864-.528-1.504-.528h-1.92v3.856h1.92Z"
      fill="#000"
    />
    <path
      d="M49.996 125.996c-.09 5.405.203 10.81.877 16.174 2.448 19.058 9.715 33.135 20.286 41.789M126.893 81.409l-86.944 50.16M71.16 175.042v17.835"
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

export default SvgProtrusion03Dims;
